import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelStandbyEntryCompletionResultRequest,
  failStandbyEntryCompletionResult,
  setStandbyEntryCompletionResult,
  setStandbyEntryCompletionResultFromApi,
  updateStandbyEntryCompletionResult,
  updateStandbyEntryCompletionResultFromApi,
} from './standby-entry-completion-result.actions';

/**
 * Service to handle async StandbyEntryCompletionResult actions
 */
@Injectable()
export class StandbyEntryCompletionResultEffect {
  /**
   * Set the state with the reply content, dispatch failStandbyEntryCompletionResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setStandbyEntryCompletionResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setStandbyEntryCompletionResult({ model: reply, requestId: action.requestId }),
        (error, action) => of(failStandbyEntryCompletionResult({ error, requestId: action.requestId })),
        cancelStandbyEntryCompletionResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failStandbyEntryCompletionResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateStandbyEntryCompletionResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateStandbyEntryCompletionResult({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failStandbyEntryCompletionResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
